import { RawUserStatistics } from "../types/api/userStatistics";
import { UserStatistics } from "../types/ui/userStatistics";

export function toUserStatistics(raw: RawUserStatistics): UserStatistics {
  return {
    userId: raw.user_id,
    scenarios: raw.scenarios.map((s) => ({
      name: s.scenario_name,
      bestHitFactor: s.best_hit_factor,
      lastHitFactor: s.last_hit_factor,
      updatedAt: new Date(s.update_time * 1000),
    })),
  };
}
